// import inventory from './inventory';
// import order from './order';
// import user from './user';
import profile from "./profile";
// import cart from './cart';
// import checkout from './checkout'
import individual_customer from "./individual_customer";
import company_customer from "./company_customer";
import customer_location_details from "./customer_location_details";
import driver_management from "./driver_management";
import driver_update from "./driver_update";
import employee from "./employee";
import new_driver_create from "./new_driver_create";
import new_driver_list from "./new_driver_list";
import user_create from "./user_create";
import order from "./order";
import order_setting from "./order-setting";
import add_to_batch from "./add-to-batch";
import individual_operational_hours from "./individual_operational_hours";

/**
 * @dev Effective 26 August 2024, for consistency:
 * -> file name: use dash -
 * -> export name: use underscore _
 */
import fullscreen_config from "./fullscreen-config";
import customer_rate_table from "./customer-rate-table";

export default {
  // inventory,
  order,
  // user,
  profile,
  employee,
  individual_customer,
  individual_operational_hours,
  company_customer,
  customer_location_details,
  driver_management,
  driver_update,
  new_driver_create,
  new_driver_list,
  user_create,
  order_setting,
  add_to_batch,
  fullscreen_config,
  customer_rate_table,
  // cart,
  // checkout
};
